"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostRunLog = getPostRunLog;
exports.getPreRunLog = getPreRunLog;
function getPostRunLog({ className, method, result, suffix }) {
    return `Called [${className}.${method}] which returned [${JSON.stringify(result)}]${suffix}`;
}
function getPreRunLog({ args, className, method }) {
    return `Calling [${className}.${method}] with args [${args.map((a) => JSON.stringify(a)).join(', ')}]`;
}
//# sourceMappingURL=utils.js.map